// extracted by mini-css-extract-plugin
export default {"answers":"zCrFZ","button":"QXAPB"};